{
  "app_name": "Impact Golf",
  "app_banner_copy": "Pelaa sujuvammin mobiilisovelluksella",
  "app_banner_install": "Asenna",
  "app_banner_dismiss": "Sulje",
  "app_profile_row": "Lataa mobiilisovellus",
  "app_store_ios": "App Store",
  "app_store_android": "Google Play",
  "app_platform_ios": "iPhone",
  "app_platform_android": "Android"
}
